​import { actionTypes } from '../actionTypes';
import * as  apiService from '../apiService'

export function fetchProductionSpeedReports(yearFilter: string, monthFilter: string, salesRepfilter: string) {
    return (dispatch: any) => {
        dispatch(fetchProductionSpeedReportsBegin());
        return fetch(apiService.productionSpeedReport())
            .then(handleErrors)
            .then(res => res.json())
            .then(json => {
                dispatch(fetchProductionSpeedReportsSuccess(json.data, yearFilter, monthFilter, salesRepfilter));
                return json.data;
            })
            .catch(error => dispatch(fetchProductionSpeedReportsFailure(error)));
    };
}

export function fetchSalesRepData() {
    const dataArry: any = [];
    return (dispatch: any) => {
        return fetch(apiService.salesPerson())
                    .then(handleErrors)
                    .then(res => res.json())
                    .then(json1 => {
                        const salesKey: string = 'salesperson';
                        dataArry[salesKey] = json1.data;
                        dispatch(fetchSalesRepDataSuccess(dataArry))
                        return dataArry;
                    })
                    .catch(error => console.log(error));
    }
}

export const fetchSalesRepDataSuccess = (salesRepData: any) => ({
    type: actionTypes.LOAD_PRODUCTION_SPEED_FILTER_SUCCESS,
    payload: { salesRepData }
})

export const fetchProductionSpeedReportsBegin = () => ({
    type: actionTypes.LOAD_PRODUCTION_SPEED_BEGIN
});

export const fetchProductionSpeedReportsSuccess = (ProductionSpeedReports: any, yearFilter: string, monthFilter: string, salesRepfilter: string) => ({
    type: actionTypes.LOAD_PRODUCTION_SPEED_SUCCESS,
    payload: { ProductionSpeedReports, yearFilter, monthFilter, salesRepfilter }
});

export const fetchProductionSpeedReportsFailure = (error: any) => ({
    type: actionTypes.LOAD_PRODUCTION_SPEED_FAILURE,
    payload: { error }
});

// Handle HTTP errors since fetch won't.
function handleErrors(response: any) {
    if (!response.ok) {
        throw Error(response.statusText);
    }
    return response;
}


// WEBPACK FOOTER //
// ./src/store/productionSpeed/actions.ts